<header class="mobile">
    <div class="header-wrapper">
        <a class="home" [routerLink]="'/home'">
            <mat-icon [svgIcon]="'app_logo'" aria-hidden></mat-icon>
        </a>
        <button
            class="icon mobile"
            matTooltip="Menu"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            (click)="toggleMobileMenu()">
            <mat-icon [svgIcon]="'hamburger'" aria-hidden></mat-icon>
        </button>
    </div>

    <div class="mobile-menu-overlay" [class.active]="isMobileMenuOpen" (click)="closeMobileMenu()">
        <div class="mobile-menu-content" (click)="$event.stopPropagation()">
            <div class="mobile-menu-container">
                <div class="mobile-menu-header">
                    <a class="mobile-logo" [routerLink]="'/home'">
                        <mat-icon [svgIcon]="'app_logo'" aria-hidden></mat-icon>
                    </a>
                    <button class="close-menu" (click)="closeMobileMenu()">
                        <mat-icon [svgIcon]="'close'" aria-hidden></mat-icon>
                    </button>
                </div>

                <div class="mobile-menu-scrollable">
                    <nav class="mobile-nav">
                        <ng-container *ngFor="let route of parent.headerShared.routes">
                            <a
                                [routerLink]="
                                    parent.headerShared.isClickableRoute(route.label) ? route.routerLink : null
                                "
                                [queryParams]="{ product: (parent.selectedProduct$ | async)?.uid }"
                                (click)="
                                    parent.headerShared.hasMegaMenu(route.label)
                                        ? toggleSubmenu(route.label)
                                        : handleMobileNavClick()
                                "
                                [class.has-submenu]="parent.headerShared.hasMegaMenu(route.label)"
                                [class.active]="parent.headerShared.isRouteActive(route.routerLink, parent.activePage)"
                                [class.submenu-open]="activeSubmenu === route.label">
                                {{ route.label }}
                                <mat-icon
                                    *ngIf="parent.headerShared.hasMegaMenu(route.label)"
                                    [svgIcon]="activeSubmenu === route.label ? 'chevron_up' : 'chevron_down'"
                                    aria-hidden>
                                </mat-icon>
                            </a>

                            <ng-container *ngIf="route.label === 'Resources'">
                                <div
                                    class="mobile-submenu"
                                    *ngIf="parent.resourcesMegaMenu$ | async as megaMenu"
                                    [class.show]="activeSubmenu === route.label">
                                    <div class="submenu-content">
                                        <h5 class="submenu-menu-title">Discover the tools that can help you succeed</h5>
                                        <ng-container *ngFor="let section of megaMenu">
                                            <div class="submenu-section">
                                                <h3 class="section-title">{{ section.title }}</h3>
                                                <ng-container *ngFor="let item of section.items">
                                                    <ng-container *ngIf="!item.authed">
                                                        <a
                                                            *ngIf="item.routerLink"
                                                            [routerLink]="item.routerLink"
                                                            [queryParams]="{
                                                                product: (parent.selectedProduct$ | async)?.uid,
                                                            }"
                                                            class="submenu-item"
                                                            (click)="handleMobileNavClick()">
                                                            {{ item.label }}
                                                        </a>
                                                        <a
                                                            *ngIf="item.href"
                                                            [href]="item.href"
                                                            target="_blank"
                                                            class="submenu-item"
                                                            (click)="closeMobileMenu()">
                                                            {{ item.label }}
                                                        </a>
                                                    </ng-container>
                                                    <ng-container *ngIf="item.authed">
                                                        <ng-container *appAuthed>
                                                            <ng-container
                                                                *ngIf="parent.portalAccess$ | async as portalAccess">
                                                                <a
                                                                    *ngIf="
                                                                        parent.headerShared.shouldShowPortal(
                                                                            item,
                                                                            portalAccess
                                                                        )
                                                                    "
                                                                    [href]="item.href"
                                                                    target="_blank"
                                                                    class="submenu-item"
                                                                    (click)="closeMobileMenu()">
                                                                    {{ item.label }}
                                                                </a>
                                                            </ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="route.label === 'Support'">
                                <div
                                    class="mobile-submenu"
                                    *ngIf="parent.supportMegaMenu$ | async as megaMenu"
                                    [class.show]="activeSubmenu === route.label">
                                    <div class="submenu-content">
                                        <h5 class="submenu-menu-title">Get the support you need</h5>
                                        <ng-container *ngFor="let section of megaMenu">
                                            <!-- Regular menu sections -->
                                            <div
                                                class="submenu-section"
                                                *ngIf="!section.type && section.items && section.items.length > 0">
                                                <h3 class="section-title">{{ section.title }}</h3>
                                                <ng-container *ngFor="let item of section.items">
                                                    <ng-container *ngIf="!item.authed">
                                                        <a
                                                            *ngIf="item.routerLink"
                                                            [routerLink]="item.routerLink"
                                                            [queryParams]="{
                                                                product: (parent.selectedProduct$ | async)?.uid,
                                                            }"
                                                            class="submenu-item"
                                                            (click)="handleMobileNavClick()">
                                                            {{ item.label }}
                                                        </a>
                                                        <a
                                                            *ngIf="item.href"
                                                            [href]="item.href"
                                                            target="_blank"
                                                            class="submenu-item"
                                                            (click)="closeMobileMenu()">
                                                            {{ item.label }}
                                                        </a>
                                                    </ng-container>
                                                    <ng-container *ngIf="item.authed">
                                                        <ng-container *appAuthed>
                                                            <a
                                                                *ngIf="item.routerLink"
                                                                [routerLink]="item.routerLink"
                                                                [queryParams]="{
                                                                    product: (parent.selectedProduct$ | async)?.uid,
                                                                }"
                                                                class="submenu-item"
                                                                (click)="handleMobileNavClick()">
                                                                {{ item.label }}
                                                            </a>
                                                            <a
                                                                *ngIf="item.href"
                                                                [href]="item.href"
                                                                target="_blank"
                                                                class="submenu-item"
                                                                (click)="closeMobileMenu()">
                                                                {{ item.label }}
                                                            </a>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </div>

                                            <!-- Spotlight section (unauthenticated users only) -->
                                            <ng-container *ngIf="section.type === 'spotlight'">
                                                <div class="submenu-section spotlight-section" *appUnauthed>
                                                    <h3 class="section-title">{{ section.title }}</h3>
                                                    <div class="spotlight-content">
                                                        <img
                                                            *ngIf="section.content?.image"
                                                            [src]="section.content.image"
                                                            [alt]="section.content?.title"
                                                            class="spotlight-image" />
                                                        <p class="spotlight-description">{{
                                                            section.content?.description
                                                        }}</p>
                                                        <a
                                                            class="spotlight-link"
                                                            (click)="handleSpotlightAction(section)">
                                                            {{ section.content?.buttonText }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </nav>

                    <div class="mobile-product-select">
                        <app-header-product-select
                            [tabIndex]="(parent.toggleSearchBar$ | async) == true ? -1 : ''"
                            color="primary"
                            (productSelected)="closeMobileMenu()">
                        </app-header-product-select>
                    </div>

                    <div class="mobile-auth-actions">
                        <ng-container *appUnauthed>
                            <div class="mobile-actions-row">
                                <button
                                    class="sign-in-btn"
                                    [class.hidden]="parent.toggleSearchBar$ | async"
                                    (click)="parent.signIn($event)">
                                    <mat-icon svgIcon="login" aria-hidden></mat-icon>
                                    Sign In
                                </button>
                                <button
                                    *ngIf="!(parent.toggleSearchBar$ | async)"
                                    class="mobile-action-btn search-btn"
                                    (click)="parent.toggleSearchBar($event)"
                                    aria-label="Search">
                                    <mat-icon class="search" svgIcon="search" aria-hidden></mat-icon>
                                    Search
                                </button>
                            </div>
                            <div class="signup-section" [class.hidden]="parent.toggleSearchBar$ | async">
                                <h5>Don't have an account?</h5>
                                <button class="signup-btn" routerLink="/sign-up" (click)="closeMobileMenu()">
                                    Sign Up
                                </button>
                            </div>
                        </ng-container>

                        <ng-container *appAuthed>
                            <a
                                class="profile-link"
                                routerLink="/profile"
                                [class.active]="parent.headerShared.isRouteActive('/profile', parent.activePage)"
                                (click)="closeMobileMenu()">
                                <div class="profile-info">
                                    <div
                                        *ngIf="parent.pfpLink$ | async as pfpLink; else initialsOnly"
                                        class="pfp-wrapper">
                                        <img [src]="pfpLink" alt="Profile picture" />
                                    </div>
                                    <ng-template #initialsOnly>
                                        <div
                                            class="initials"
                                            *ngIf="parent.initialsColors$ | async as colors"
                                            [style.background-color]="colors.backgroundColor"
                                            [style.color]="colors.textColor"
                                            >{{ parent.initials$ | async }}</div
                                        >
                                    </ng-template>
                                    <span>My Profile</span>
                                </div>
                            </a>
                            <!--Achiever's Lounge-->
                            <a
                                class="profile-link achievers-link"
                                routerLink="/profile/achievers-lounge"
                                [class.active]="
                                    parent.headerShared.isRouteActive('/profile/achievers-lounge', parent.activePage)
                                "
                                (click)="closeMobileMenu()">
                                <div class="profile-info achiever-info">
                                    <mat-icon class="trophy-icon" [svgIcon]="'trophy'" aria-hidden></mat-icon>
                                    <span>Achiever's Lounge</span>
                                </div>
                            </a>
                            <!-- User Management -->
                            <a
                                *designatedApprover
                                class="profile-link user-management-link"
                                routerLink="/user-management"
                                [class.active]="
                                    parent.headerShared.isRouteActive('/user-management', parent.activePage)
                                "
                                (click)="closeMobileMenu()">
                                <div class="profile-info achiever-info">
                                    <!--TODO: Need an icon-->
                                    <!-- <mat-icon class="trophy-icon" [svgIcon]="'trophy'" aria-hidden></mat-icon> -->
                                    <span>User Management</span>
                                </div>
                            </a>
                            <a class="profile-link" (click)="parent.signOut($event)">
                                <div class="signout-info">
                                    <div class="icon-placeholder"></div>
                                    <span>Sign Out</span>
                                </div>
                            </a>
                        </ng-container>
                    </div>

                    <div class="mobile-search-container" [class.open]="parent.toggleSearchBar$ | async">
                        <div class="search-wrapper-container">
                            <app-header-search-bar
                                [isOpen]="(parent.toggleSearchBar$ | async) === true"
                                (afterSearch)="parent.toggleSearchBar(); closeMobileMenu()">
                            </app-header-search-bar>
                            <button
                                *ngIf="parent.toggleSearchBar$ | async"
                                class="close-btn"
                                (click)="parent.toggleSearchBar($event)"
                                aria-label="Close search">
                                <mat-icon svgIcon="close" aria-hidden></mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
